/**
 * Content Versions API Client
 */

import apiClient from './client';

export interface ContentVersion {
  id: string;
  entity_type: string;
  entity_id: string;
  field_name: string;
  version: number;
  content: string;
  change_source: string;
  created_by_id: string | null;
  created_by_name?: string;
  created_at: string;
}

export const contentVersionsApi = {
  async listVersions(entityType: 'template' | 'instance', entityId: string, field = 'description'): Promise<{ items: ContentVersion[] }> {
    const endpoint = entityType === 'template' ? 'templates' : 'instances';
    const { data } = await apiClient.get(`/v1/${endpoint}/${entityId}/versions`, { params: { field } });
    return data;
  },

  async getVersion(entityType: 'template' | 'instance', entityId: string, version: number, field = 'description'): Promise<ContentVersion> {
    const endpoint = entityType === 'template' ? 'templates' : 'instances';
    const { data } = await apiClient.get(`/v1/${endpoint}/${entityId}/versions/${version}`, { params: { field } });
    return data;
  },

  async revertToVersion(entityType: 'template' | 'instance', entityId: string, version: number, field = 'description'): Promise<{ success: boolean; content: string }> {
    const endpoint = entityType === 'template' ? 'templates' : 'instances';
    const { data } = await apiClient.post(`/v1/${endpoint}/${entityId}/versions/${version}/revert`, null, { params: { field } });
    return data;
  },
};
